-- | Pure Step 3 transition state and generation helpers.
-- |
-- | This module tracks the latest queued Step 3 navigation intent while save
-- | and load work is in flight.
module Steps.Step3.Transition
    ( Step3HistoryMode(..)
    , PendingTransition
    , TransitionState
    , emptyTransitionState
    , enqueueTransition
    , latestTransition
    , transitionIsCurrent
    , finishTransition
    ) where

import Prelude

import Data.Maybe (Maybe(..))
import Data.Tuple (Tuple(..))
import Steps.WorkQueue.State (FormSectionID)

data Step3HistoryMode = PushStep3History | ReplaceStep3History

type PendingTransition =
    { generation :: Int
    , position :: Int
    , anchor :: Maybe FormSectionID
    , historyMode :: Step3HistoryMode
    }

type TransitionState =
    { active :: Boolean
    , latest :: Maybe PendingTransition
    , nextGeneration :: Int
    }

emptyTransitionState :: TransitionState
emptyTransitionState =
    { active: false
    , latest: Nothing
    , nextGeneration: 0
    }

enqueueTransition :: TransitionState -> Int -> Maybe FormSectionID -> Tuple Boolean TransitionState
enqueueTransition state position anchor =
    let generation = state.nextGeneration + 1
        historyMode = case state.latest of
            Just latest -> latest.historyMode
            Nothing -> PushStep3History
        pending = { generation, position, anchor, historyMode }
    in Tuple
        (not state.active)
        ( state
            { active = true
            , latest = Just pending
            , nextGeneration = generation
            }
        )

latestTransition :: TransitionState -> Maybe PendingTransition
latestTransition = _.latest

transitionIsCurrent :: TransitionState -> Int -> Boolean
transitionIsCurrent state generation = case state.latest of
    Just pending -> pending.generation == generation
    Nothing -> false

finishTransition :: TransitionState -> Int -> Tuple Boolean TransitionState
finishTransition state generation = case state.latest of
    Just pending | pending.generation == generation ->
        Tuple true $
            state
                { active = false
                , latest = Nothing
                }
    _ -> Tuple false state
